export default __webpack_public_path__ + "static/media/p05 p04.c890158e.jpg";